// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/audit.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/audit.proto.
 */
export const file_console_admin_v1_audit: GenFile = /*@__PURE__*/
  fileDesc("Chxjb25zb2xlL2FkbWluL3YxL2F1ZGl0LnByb3RvEhBjb25zb2xlLmFkbWluLnYxIvcCCgpBdWRpdEV2ZW50EgoKAmlkGAEgASgJEg4KBm9yZ19pZBgCIAEoCRIvCgtvY2N1cnJlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLcmVjZWl2ZWRfYXQYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEiYKBWFjdG9yGAUgASgLMhcuY29uc29sZS5hZG1pbi52MS5BY3RvchIOCgZhY3Rpb24YBiABKAkSKAoGdGFyZ2V0GAcgASgLMhguY29uc29sZS5hZG1pbi52MS5UYXJnZXQSDwoHb3V0Y29tZRgIIAEoCRIKCgJpcBgJIAEoCRISCgp1c2VyX2FnZW50GAogASgJEhEKCWRldmljZV9pZBgLIAEoCRIOCgZzb3VyY2UYDCABKAkSJwoGZGV0YWlsGA0gASgLMhcuZ29vZ2xlLnByb3RvYnVmLlN0cnVjdBIMCgRoYXNoGA4gASgJIi8KBUFjdG9yEgwKBHR5cGUYASABKAkSCgoCaWQYAiABKAkSDAoEbmFtZRgDIAEoCSIwCgZUYXJnZXQSDAoEdHlwZRgBIAEoCRIKCgJpZBgCIAEoCRIMCgRuYW1lGAMgASgJIqMCChFRdWVyeUF1ZGl0UmVxdWVzdBIOCgZvcmdfaWQYASABKAkSKAoEZnJvbRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASJgoCdG8YAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg8KB2FjdGlvbnMYBCADKAkSEAoIYWN0b3JfaWQYBSABKAkSEQoJZGV2aWNlX2lkGAYgASgJEhEKCXRhcmdldF9pZBgHIAEoCRIRCglwYWdlX3NpemUYCCABKA0SEgoKcGFnZV90b2tlbhgJIAEoCRIZChFhbGxfb3JnYW5pemF0aW9ucxgKIAEoCBIOCgZvZmZzZXQYCyABKA0SEQoJc2hhcmVfaWRzGAwgAygJImoKElF1ZXJ5QXVkaXRSZXNwb25zZRIsCgZldmVudHMYASADKAsyHC5jb25zb2xlLmFkbWluLnYxLkF1ZGl0RXZlbnQSFwoPbmV4dF9wYWdlX3Rva2VuGAIgASgJEg0KBXRvdGFsGAMgASgNIlgKEkV4cG9ydEF1ZGl0UmVxdWVzdBIyCgVxdWVyeRgBIAEoCzIjLmNvbnNvbGUuYWRtaW4udjEuUXVlcnlBdWRpdFJlcXVlc3QSDgoGZm9ybWF0GAIgASgJIlsKE0V4cG9ydEF1ZGl0UmVzcG9uc2USFAoMZG93bmxvYWRfdXJsGAEgASgJEi4KCmV4cGlyZXNfYXQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wMsMBCgxBdWRpdFNlcnZpY2USVwoKUXVlcnlBdWRpdBIjLmNvbnNvbGUuYWRtaW4udjEuUXVlcnlBdWRpdFJlcXVlc3QaJC5jb25zb2xlLmFkbWluLnYxLlF1ZXJ5QXVkaXRSZXNwb25zZRJaCgtFeHBvcnRBdWRpdBIkLmNvbnNvbGUuYWRtaW4udjEuRXhwb3J0QXVkaXRSZXF1ZXN0GiUuY29uc29sZS5hZG1pbi52MS5FeHBvcnRBdWRpdFJlc3BvbnNlYgZwcm90bzM", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message console.admin.v1.AuditEvent
 */
export type AuditEvent = Message<"console.admin.v1.AuditEvent"> & {
  /**
   * ULID; sorts by time.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * When it happened, as the source knew it. For device-reported events this
   * is the tablet's wall clock and is not trusted.
   *
   * @generated from field: google.protobuf.Timestamp occurred_at = 3;
   */
  occurredAt?: Timestamp | undefined;

  /**
   * When the console recorded it.
   *
   * @generated from field: google.protobuf.Timestamp received_at = 4;
   */
  receivedAt?: Timestamp | undefined;

  /**
   * @generated from field: console.admin.v1.Actor actor = 5;
   */
  actor?: Actor | undefined;

  /**
   * @generated from field: string action = 6;
   */
  action: string;

  /**
   * @generated from field: console.admin.v1.Target target = 7;
   */
  target?: Target | undefined;

  /**
   * `ok`, `refused`, `failed`.
   *
   * @generated from field: string outcome = 8;
   */
  outcome: string;

  /**
   * @generated from field: string ip = 9;
   */
  ip: string;

  /**
   * @generated from field: string user_agent = 10;
   */
  userAgent: string;

  /**
   * @generated from field: string device_id = 11;
   */
  deviceId: string;

  /**
   * `console`, `device`, `idp_webhook`, `system`.
   *
   * @generated from field: string source = 12;
   */
  source: string;

  /**
   * @generated from field: google.protobuf.Struct detail = 13;
   */
  detail?: JsonObject | undefined;

  /**
   * @generated from field: string hash = 14;
   */
  hash: string;
};

/**
 * Describes the message console.admin.v1.AuditEvent.
 * Use `create(AuditEventSchema)` to create a new message.
 */
export const AuditEventSchema: GenMessage<AuditEvent> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 0);

/**
 * @generated from message console.admin.v1.Actor
 */
export type Actor = Message<"console.admin.v1.Actor"> & {
  /**
   * `user`, `device`, `system`, `idp`.
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message console.admin.v1.Actor.
 * Use `create(ActorSchema)` to create a new message.
 */
export const ActorSchema: GenMessage<Actor> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 1);

/**
 * @generated from message console.admin.v1.Target
 */
export type Target = Message<"console.admin.v1.Target"> & {
  /**
   * `user`, `device`, `key`, `org`, `policy`, `mapping`, `session`.
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message console.admin.v1.Target.
 * Use `create(TargetSchema)` to create a new message.
 */
export const TargetSchema: GenMessage<Target> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 2);

/**
 * @generated from message console.admin.v1.QueryAuditRequest
 */
export type QueryAuditRequest = Message<"console.admin.v1.QueryAuditRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: google.protobuf.Timestamp from = 2;
   */
  from?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp to = 3;
   */
  to?: Timestamp | undefined;

  /**
   * Prefix match on action, e.g. `operator.` or `key.promoted`.
   *
   * @generated from field: repeated string actions = 4;
   */
  actions: string[];

  /**
   * @generated from field: string actor_id = 5;
   */
  actorId: string;

  /**
   * @generated from field: string device_id = 6;
   */
  deviceId: string;

  /**
   * @generated from field: string target_id = 7;
   */
  targetId: string;

  /**
   * @generated from field: uint32 page_size = 8;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 9;
   */
  pageToken: string;

  /**
   * MotionSafe staff only: every organization's events, and those recorded
   * against none, whatever organization is named.
   *
   * @generated from field: bool all_organizations = 10;
   */
  allOrganizations: boolean;

  /**
   * Rows to skip, newest first, for a numbered page. Used in place of
   * `page_token`.
   *
   * @generated from field: uint32 offset = 11;
   */
  offset: number;

  /**
   * Events whose detail names one of these `share_id`s: both halves of a
   * share, its end, and any refusal, whatever page they fall on. At most
   * 100. Scoped like every other filter.
   *
   * @generated from field: repeated string share_ids = 12;
   */
  shareIds: string[];
};

/**
 * Describes the message console.admin.v1.QueryAuditRequest.
 * Use `create(QueryAuditRequestSchema)` to create a new message.
 */
export const QueryAuditRequestSchema: GenMessage<QueryAuditRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 3);

/**
 * @generated from message console.admin.v1.QueryAuditResponse
 */
export type QueryAuditResponse = Message<"console.admin.v1.QueryAuditResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.AuditEvent events = 1;
   */
  events: AuditEvent[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * How many events match, across every page.
   *
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.QueryAuditResponse.
 * Use `create(QueryAuditResponseSchema)` to create a new message.
 */
export const QueryAuditResponseSchema: GenMessage<QueryAuditResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 4);

/**
 * @generated from message console.admin.v1.ExportAuditRequest
 */
export type ExportAuditRequest = Message<"console.admin.v1.ExportAuditRequest"> & {
  /**
   * @generated from field: console.admin.v1.QueryAuditRequest query = 1;
   */
  query?: QueryAuditRequest | undefined;

  /**
   * `csv` or `jsonl`.
   *
   * @generated from field: string format = 2;
   */
  format: string;
};

/**
 * Describes the message console.admin.v1.ExportAuditRequest.
 * Use `create(ExportAuditRequestSchema)` to create a new message.
 */
export const ExportAuditRequestSchema: GenMessage<ExportAuditRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 5);

/**
 * @generated from message console.admin.v1.ExportAuditResponse
 */
export type ExportAuditResponse = Message<"console.admin.v1.ExportAuditResponse"> & {
  /**
   * @generated from field: string download_url = 1;
   */
  downloadUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.ExportAuditResponse.
 * Use `create(ExportAuditResponseSchema)` to create a new message.
 */
export const ExportAuditResponseSchema: GenMessage<ExportAuditResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_audit, 6);

/**
 * The audit log: append-only, hash-chained per organization. Org admins see
 * their organization; staff see all. Actions are stable dotted strings
 * (`operator.login`, `key.promoted`, `seat.limit_refused`, ...) and the
 * console shows them verbatim so the state words on every page match the log.
 *
 * @generated from service console.admin.v1.AuditService
 */
export const AuditService: GenService<{
  /**
   * @generated from rpc console.admin.v1.AuditService.QueryAudit
   */
  queryAudit: {
    methodKind: "unary";
    input: typeof QueryAuditRequestSchema;
    output: typeof QueryAuditResponseSchema;
  },
  /**
   * Produces a signed CSV or JSONL of the query, delivered as a time-limited
   * download URL. Audited as `audit.exported`.
   *
   * @generated from rpc console.admin.v1.AuditService.ExportAudit
   */
  exportAudit: {
    methodKind: "unary";
    input: typeof ExportAuditRequestSchema;
    output: typeof ExportAuditResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_audit, 0);

